import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import _actions from '../actions';
import { compareAsc } from 'date-fns';
import Countdown, { zeroPad } from 'react-countdown-now';
import packageKey from '../utils/packageKey';
import { first } from '../utils';

class ReservationTimerContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timer: null
    };
  }
  render() {
    const {
      sale: { sale = {} },
      children,
      actions,
      inventory
    } = this.props;

    const reservedPackages = sale.reservedPackages || {};

    var byExp = Object.keys(reservedPackages)
      .map(item_id => {
        return { ...reservedPackages[item_id], item_id };
      })
      .sort((a, b) => {
        return compareAsc(a.expires, b.expires);
      });

    // only show soonest expiring countdown in list
    let left = null;
    if (byExp != null && byExp.length > 0) {
      left = byExp
        .filter(pkg => pkg.expires)
        .map((pkg, idx) => (
          <Countdown
            key={pkg.item_id}
            date={pkg.expires}
            renderer={({ minutes, seconds }) => (
              <span style={{ display: idx === 0 ? 'initial' : 'none' }}>
                <span className={`${minutes < 2 && 'dark-red'}`}>
                  {`${zeroPad(minutes, 2)}:${zeroPad(seconds, 2)}`}
                </span>
                &nbsp;left
              </span>
            )}
            onComplete={() => {
              setTimeout(
                () => {
                  const inventoryPackages =
                    inventory.packages[packageKey(sale.day)] || [];
                  if (inventoryPackages == null) return;

                  const expiredPkg = first(
                    inventoryPackages,
                    _pkg => _pkg.item_id == pkg.item_id
                  );
                  if (expiredPkg == null) return;

                  const descrip = expiredPkg.descrip;
                  actions.clearReservations();
                  actions.expirePackage(pkg.item_id, descrip);
                  actions.transitionTo('/');
                },
                idx > 0 ? idx * 1100 : idx
              );
            }}
          />
        ));
    }

    return (
      <div className="ReservationTimer">
        <div className="ReservationTimer__child">{children}</div>
        <div className="ReservationTimer__timer">{left}</div>
      </div>
    );
  }
}

ReservationTimerContainer.propTypes = {
  sale: PropTypes.object,
  children: PropTypes.any,
  actions: PropTypes.object,
  inventory: PropTypes.object
};

const mapStateToProps = state => ({
  sale: state.sale,
  inventory: state.inventory
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(_actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReservationTimerContainer));
